import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Grid, TextField, Card, CardContent, Button, Box, MenuItem, FormControl, InputLabel, FormHelperText, makeStyles, Stack } from '@material-ui/core';
// shared - core components
import Toast from '../../../../shared/components/Toast/Toast'
import LoaderContent from '../../../../shared/components/Loader/LoaderContent.jsx'
//SDK
import { ThinkificService } from '@sdk-point/talisis';

// @local
import { useStyles } from '../../../../assets/styles/jss/pages/microcredentials/useStyles';

const ThinkificServiceSDK = new ThinkificService(
    process.env.REACT_APP_ENV_V2,
    process.env.REACT_APP_X_API_KEY_V2
);



const BodyRequest = ({ readOnly = false, onClose, onSuccess, formData, onLoadingChange }) => {
    const classes = useStyles();
    const location = useLocation();
    const formFromState = location.state?.form;
    const [loading, setLoading] = React.useState(false);
    const [toastProps, setToastProps] = React.useState({ message: "", severity: "", open: false });
    const [errors, setErrors] = React.useState({});
    const [form, setForm] = React.useState({ id: null, name: "", templatePoc: "", credentialId: "" });
    const [credentialsOptions, setCredentialOptions] = React.useState([]);



    useEffect(() => {
        const initialForm = formData || formFromState;
        if (initialForm) setForm(initialForm);
        getCredentials();
    }, [formData, formFromState]);

    const handleChange = event => {
        const { name, value } = event.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleFinishedToast = () => setToastProps(prev => ({ ...prev, open: false }));

    const getCredentials = async () => {
        const payloadgetCatalogs = { CatalogType: "credential" };
        const credentialData = await ThinkificServiceSDK.getCatalogs(payloadgetCatalogs);
        if (credentialData.success) {
            const credential = credentialData.data.map(item => ({ id: item.id, label: item.name }));
            setCredentialOptions(credential);
        }
    };


    const validateForm = () => {
        let newErrors = {};

        const validateField = (value) => {
            const strValue = (value ?? "").toString().trim();
            if (strValue === "") {
                 return `campo requerido`;
            }
            return null;
        };

        const nameError = validateField(form.name);
        const templatePocError = validateField(form.templatePoc);
        const credentialIdError = validateField(form.credentialId);

        if (nameError) newErrors.name = nameError;
        if (templatePocError) newErrors.templatePoc = templatePocError;
        if (credentialIdError) newErrors.credentialId = credentialIdError;

        return newErrors;
    };


    const handleSubmit = async () => {
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setToastProps({ severity: "error", open: true, message: "Completa todos los campos obligatorios" });
            return;
        }

        setErrors({});
        setLoading(true);
        if (onLoadingChange) {
            console.log('Activando spinner...');
            onLoadingChange(true);
        } else {
            console.log('onLoadingChange no está definido');
        }

        try {
            const cleanForm = {
                ...form,
                name: (form.name || "").toString().trim(),
                templatePoc: (form.templatePoc || "").toString().trim()
            };



            if (cleanForm.id) {
                // EDITAR
                const payloadUpdate = {
                    CatalogType: "microcredential",
                    id: cleanForm.id,
                    name: cleanForm.name,
                    template_poc: cleanForm.templatePoc,
                    credential_id: cleanForm.credentialId
                };

                await ThinkificServiceSDK.updateCatalogs(payloadUpdate);
                setToastProps({ severity: "success", open: true, message: "La acción se realizó correctamente" });

                setTimeout(() => {
                    if (onSuccess) onSuccess();
                }, 800);
            } else {
                // CREAR
                const payloadCreate = {
                    CatalogType: "microcredential",
                    name: cleanForm.name,
                    templatePoc: cleanForm.templatePoc,
                    credentialId: cleanForm.credentialId
                };

                await ThinkificServiceSDK.postCreateCatalogs(payloadCreate);
                setToastProps({ severity: "success", open: true, message: "La acción se realizó correctamente" });

                setTimeout(() => {
                    if (onSuccess) onSuccess();
                }, 800);
            }

        } catch (error) {
            console.error("Error al guardar registro", error);
            setToastProps({ severity: "error", open: true, message: "Error al guardar: Nombre ya existe" });
        } finally {
            setLoading(false);
            if (onLoadingChange) {
                console.log('Desactivando spinner...');
                onLoadingChange(false);
            }
        }
    };


    const isEditMode = Boolean(form.id);



    return (
        <div>
            {/* <Breadcrumb items={breadcrumbItems} /> */}
            <Grid container spacing={3}>
                <Grid container item xs={12}>
                    <LoaderContent>
                        <Card>
                            <CardContent>
                                <Grid container spacing={3}>
                                    <Grid container item xs={12} spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                required
                                                label="Nombre"
                                                name="name"
                                                margin="dense"
                                                variant="outlined"
                                                fullWidth
                                                value={form.name || ""}
                                                onChange={handleChange}
                                                error={Boolean(errors.name)}
                                                helperText={errors.name}
                                                disabled={readOnly}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                required
                                                label="Template pok"
                                                name="templatePoc"
                                                margin="dense"
                                                variant="outlined"
                                                fullWidth
                                                value={form.templatePoc}
                                                onChange={handleChange}
                                                error={Boolean(errors.templatePoc)}
                                                helperText={errors.templatePoc}
                                                disabled={readOnly}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                select
                                                required
                                                label="Tipo de credencial"
                                                name="credentialId"
                                                margin="dense"
                                                variant="outlined"
                                                fullWidth
                                                value={form.credentialId || ""}
                                                onChange={handleChange}
                                                error={Boolean(errors.credentialId)}
                                                helperText={errors.credentialId}
                                                disabled={readOnly}
                                            >
                                                {credentialsOptions.map(option => (
                                                    <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </LoaderContent>
                </Grid>

                <Grid container item xs={12}>



                    <Box display="flex" justifyContent="flex-end" width="100%" backgroundColor={"white"} marginRight={"32px"}>


                        {!readOnly && (
                            <>
                                <Button
                                    className={classes.cancelButton}
                                    //color="default"
                                    variant="contained"
                                    onClick={onClose}
                                    disabled={loading}
                                >
                                    Regresar
                                </Button>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {isEditMode ? "Actualizar" : "Guardar"}
                                </Button>
                            </>
                        )}
                    </Box>
                </Grid>
                <Toast {...toastProps} onFinished={handleFinishedToast} />
            </Grid>
        </div>
    );
};

export default BodyRequest;
